module.exports = __webpack_public_path__ + "img/arrow-mobile2.b89e30e.svg";